<template>
    <div class="form-group__wrapper">
        <label :for="slug" class="form-group__label" :class="{ disabled: isDisabled, isSmall: isSmallLabel }">
            {{ label }}:
            <div v-if="description" class="form-group__tooltip">
                <IconTooltip :tooltipMessage="description" :isHtml="true"></IconTooltip>
            </div>
        </label>
        <div v-for="(filterItem, index) in filterValues" :key="index" class="checkbox-item">
            <input type="radio" class="form-group__radio" :id="`${slug}_${index}`" :value="filterItem.title" :checked="index === selectedIndex" :disabled="filterItem.isDisabled || isDisabled" @click="onRadioChange(index)" />
            <label :for="`${slug}_${index}`" class="form-group__item-label" :class="{ disabled: filterItem.isDisabled }">{{ filterItem.title }}<span v-if="showNumResults"> ({{ filterItem.numResults }})</span></label>
        </div>
    </div>
</template>

<script lang="ts">
import IconTooltip from "Vue/components/lockDesigner/components/shared/IconTooltip.vue";

export default {
    name: 'RadioGroup',
    components: {IconTooltip},
    props: {
        slug: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        hasInfoButton: {
            type: Boolean,
            default: false,
        },
        filterValues: {
            type: Array,
            required: true,
        },
        isSmallLabel: {
            type: Boolean,
            default: false,
        },
        showNumResults: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selectedIndex: -1, // Track the selected index, -1 means none selected
        };
    },
    watch: {
        filterValues: {
            handler(newOptions) {
                // If an option with isSelected is found, set the selectedIndex accordingly
                if (newOptions.length) {
                    const selectedOptionIndex = newOptions.findIndex((option) => option.isSelected);
                    this.selectedIndex = selectedOptionIndex !== -1 ? selectedOptionIndex : -1;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onRadioChange(index) {
            let filterValuesCopy = [...this.filterValues];

            this.selectedIndex = index;

            filterValuesCopy = filterValuesCopy.map((option, index) => {
                return { ...option, isSelected: index === this.selectedIndex };
            });
            let newOptions = JSON.parse(JSON.stringify(filterValuesCopy));
            this.$emit('radioChange', newOptions);
        },
        onInfoButtonClick() {
            this.$emit('infoButtonClick');
        },
    },
};
</script>
